export const availableLanguages = [
  { name: "English", code: "en" },
  { name: "Español", code: "es" },
  { name: "Català", code: "ca" },
  { name: "Português", code: "pt" },
];
export const translations = {
  login: {
    en: "Login",
    es: "Login",
    ca: "Login",
    eu: "",
    gl: "",
    pt: "Login",
    fr: "",
    it: "",
    de: "",
  },
  continue: {
    en: "Continue",
    es: "Continuar",
    ca: "Continuar",
    eu: "",
    gl: "",
    pt: "Continuar",
    fr: "",
    it: "",
    de: "",
  },
  realmName: {
    en: "Company name",
    es: "Nombre de empresa",
    ca: "Nom d'empresa",
    eu: "",
    gl: "",
    pt: "Nome da empresa",
    fr: "",
    it: "",
    de: "",
  },
  realmNameWarning: {
    en: "Please enter your company name",
    es: "Por favor introduzca el nombre de empresa",
    ca: "Introduïu el nom d'empresa",
    eu: "",
    gl: "",
    pt: "Por favor introduza o nome da empresa",
    fr: "",
    it: "",
    de: "",
  },
  loggingIn: {
    en: "Processing...",
    es: "Procesando...",
    ca: "Tramitant...",
    eu: "",
    gl: "",
    pt: "Processamento...",
    fr: "",
    it: "",
    de: "",
  },
  hello: {
    en: "Hello",
    es: "Hola",
    ca: "Hola",
    eu: "",
    gl: "",
    pt: "Oi",
    fr: "",
    it: "",
    de: "",
  },
  redirectMsg: {
    en: "we are redirecting you...",
    es: "Te estamos redirigiendo...",
    ca: "T'estem redirigint...",
    eu: "",
    gl: "",
    pt: "Você está sendo redirecionado...",
    fr: "",
    it: "",
    de: "",
  },

  noMfaMsg: {
    en: "Don't have multi-factor authentication enabled?",
    es: "¿No tienes activada la autenticación multifactor?",
    ca: "No tens activada l'autenticació multifactor?",
    eu: "Ez duzu multifaktoreko autentifikazioa gaituta?",
    gl: "Non tes activada a autenticación multifactor?",
    pt: "Não tens a autenticação multifator ativada?",
    fr: "Vous n'avez pas activé l'authentification multifacteur ?",
    it: "Non hai attivato l'autenticazione a più fattori?",
    de: "Hast du die Multi-Faktor-Authentifizierung nicht aktiviert?",
  },
  noMfaLinkText: {
    en: "Sign in with the classic login",
    es: "Inicia sesión con el login clásico",
    ca: "Inicia sessió amb el login clàssic",
    eu: "Hasi saioa login klasikoarekin",
    gl: "Inicia sesión co login clásico",
    pt: "Inicia sessão com o login clássico",
    fr: "Connectez-vous avec le login classique",
    it: "Accedi con il login classico",
    de: "Melde dich mit dem klassischen Login an",
  },
};
